export default __webpack_public_path__ + "static/og-e393b9812b4834a28e29c874f0cca3f9.jpeg";